import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

const POLICY_REDIRECTS: Record<string, string> = {
  "/shipping-policy": "https://ironhavensupply.com/pages/shipping-policy",
  "/return-policy": "https://ironhavensupply.com/pages/return-refund-policy",
  "/returns": "https://ironhavensupply.com/pages/return-refund-policy",
  "/privacy-policy": "https://ironhavensupply.com/policies/privacy-policy",
  "/terms-of-service": "https://ironhavensupply.com/policies/terms-of-service",
  "/terms": "https://ironhavensupply.com/policies/terms-of-service",
  "/cookie-policy": "https://ironhavensupply.com/policies/privacy-policy",
  "/payment-policy": "https://ironhavensupply.com/policies/terms-of-service",
};

export default function NotFound() {
  const location = useLocation();
  const shopifyTarget = POLICY_REDIRECTS[location.pathname];

  useEffect(() => {
    if (shopifyTarget) {
      window.location.replace(shopifyTarget);
    }
  }, [shopifyTarget]);

  if (shopifyTarget) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center px-6">
          <p className="text-gray-400 text-sm mb-3">Redirecting to our official policy page…</p>
          <a
            href={shopifyTarget}
            className="text-amber-600 underline text-sm font-medium cursor-pointer"
          >
            Click here if you are not redirected
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center text-center px-4">
      <div className="text-8xl font-black text-gray-100 select-none mb-4">404</div>
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Page Not Found</h1>
      <p className="text-gray-500 text-sm mb-8 max-w-sm">
        Looks like this page doesn&apos;t exist. Head back home or visit our store.
      </p>
      <div className="flex flex-col sm:flex-row items-center gap-3">
        <Link
          to="/"
          className="bg-amber-500 hover:bg-amber-400 text-white text-sm font-semibold px-6 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
        >
          Back to Home
        </Link>
        <a
          href="https://ironhavensupply.com"
          target="_blank"
          rel="noopener noreferrer"
          className="border border-gray-200 hover:border-amber-400 text-gray-700 hover:text-amber-600 text-sm font-semibold px-6 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
        >
          Visit Our Store
        </a>
      </div>
    </div>
  );
}